import { useQuery } from 'react-query';
import { makeRequest } from '../../api/makeRequest';
import { useMemo } from 'react';
import { flattenObject } from '../../helpers/objectHelpers';

interface UseGetCollectionQueryOptions {
    collectionKey: string | (string|number)[];
    path: string;
    params: Record<string, any>;
    refetchInterval?: number;
    keepPreviousData?: boolean;
    cacheTime?: number;
}

export function useGetCollectionQuery<TResponse>({
     collectionKey,
     path,
     params,
     refetchInterval,
     keepPreviousData = true,
     cacheTime
 }: UseGetCollectionQueryOptions) {
    const flattenedParams = useMemo(() => flattenObject(params), [params]);
    const collectionKeyArray = Array.isArray(collectionKey) ? collectionKey : [collectionKey];

    const queryKey = [...collectionKeyArray, ...Object.values(flattenedParams)];

    return useQuery<TResponse>(
        queryKey,
        () =>
            makeRequest({
                method: 'GET',
                path: path,
                data: flattenedParams
            }),
        {
            refetchInterval,
            keepPreviousData,
            cacheTime
        }
    );
}
